export default class PauseButton {
    constructor(scene, characterSelected) {
        this.scene = scene;
        this.characterSelected = characterSelected;
        const button =  scene.add.image(800 - 16, 16, `pause`, 0).setScale(1).setOrigin(1, 0).setScrollFactor(0).setInteractive();
        // button.width = 10;
        // button.height = 10;
        button.on('pointerdown', () => {
            // button.setTexture('buttoned_pressed');
            button.setAlpha(0.4);
            this.scene.events.emit('pause-event');

            
            // scene.scene.launch('Pause', {scene: scene.scene.key, characterSelected});
            // scene.scene.pause();
        }).on('pointerup', () => {
            scene.scene.launch('Pause', {scene: scene.scene.key, characterSelected});
            scene.scene.pause();
            scene.sound.mute = true;
            button.setAlpha(1)
        });
        
            
    }

    pauseByEvent() {
        if(this.scene.scene) {
            this.scene.scene.launch('Pause', {scene: this.scene.scene.key, characterSelected: this.characterSelected});
            this.scene.scene.pause();
            this.scene.sound.mute = true;
        }
    }
}